module.exports = __webpack_public_path__ + "static/media/10.e01940f8.jpg";